import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { AudioPlayerService } from '../../services/audio-player.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.less']
})
export class RegisterComponent implements OnInit {
  registrationForm: FormGroup;
  errorMessage: string = '';
  constructor(
    public audio: AudioPlayerService,
    private authService: AuthService,
    private router: Router,
    private fb: FormBuilder) {
      this.registrationForm = this.fb.group({
        username: ['', Validators.required],
        // TODO: passwordValidation
        password: ['', Validators.required],
        passwordValidation: ['', Validators.required ],
        email: ['', [Validators.required, Validators.email] ]
      });
     }

  ngOnInit() {

  }

  login() {
    this.router.navigate(['createAvatar']);
  }

  register() {
    this.errorMessage = '';
    if (this.registrationForm.controls.password.value != this.registrationForm.controls.passwordValidation.value) {
      this.errorMessage = this.audio.getPlay('register_wachtwoorden_komen_niet_overeen');
      return;
    }
    if (this.registrationForm.valid) {
      this.authService.register(
        this.registrationForm.controls.username.value,
        this.registrationForm.controls.password.value,
        this.registrationForm.controls.email.value).subscribe(() => {
          this.router.navigate(['/dashboard']);
        }, error => {
            if (error.error.code === 3) {
              console.error("already in use");
              this.errorMessage = this.audio.getPlay('register_naam_al_in_gebruik');
            }
        });
    } else {
        alert('Gegevens onjuist!');
    }
  }
}
